<template>
	<div class="sidebar-mobile-container">
		<div class="close-container" @click="closeMobile">
			<span> X بستن منو</span>
		</div>
		<!-- <div class="logo-container">
			<img :src="this.$PATH.GET_IMAGE_PATH('logo.svg')" alt="" v-if="!closeMenu" />
		</div> -->
		
		<div class="menu-item-container" :class="{ mta: closeMenu }">
			<ul class="navigation navigation-main" id="nav" data-menu="menu-navigation">
				<div v-for="menu in menuList" :key="menu.id">
					<li v-if="menu.has_submenu === false" class="nav-item mr-4">
						<router-link
							:to="menu.frontend_route_url"
							class="d-flex"
							:class="{ 'justify-center': closeMenu }"
						>
							<!-- <span class="iconify" data-icon="clarity:dashboard-line"></span> -->
							<img class="iconify" :src="menu.deactive_icon" />
							<span class="menu-title" data-i18n="Dashboard" v-if="!closeMenu">{{
								menu.verbose_name
							}}</span>
						</router-link>
					</li>
					<SiderbarDropdown
						v-else
						class="side-dropdown"
						:title="menu.verbose_name"
						:iconUrl="menu.deactive_icon"
						:mainRoute="menu.frontend_route_url"
					>
						<template slot="navItems" v-if="!closeMenu">
							<li
								v-for="children in menu.children"
								:key="children.id"
								class="nav-item inside submenu mb-0"
							>
								<router-link
									:to="children.frontend_route_url"
									class="nav-link"
									:class="{ 'justify-center': closeMenu }"
								>
									<!-- <span class="iconify" data-icon="bi:plus-square"></span> -->
									<img class="iconify" :src="children.deactive_icon" />
									<span class="menu-title" v-if="!closeMenu">{{ children.verbose_name }}</span>
								</router-link>
							</li>
							<br />
						</template>
					</SiderbarDropdown>
				</div>
			</ul>
		</div>
	</div>	
</template>
<script>
import SiderbarDropdown from '../../components/SiderbarDropdown/index.vue';

export default {
	components: {
		SiderbarDropdown,
	},
	
	methods: {
		async getMenuList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.MENU_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_active=true',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.menuList = res.data;
			}
		},
		closeMobile() {
			this.$STORE.commit('appConfig/openMenuMobile', !this.$STORE.state.appConfig.mobileMobile);
		},
	},
	data() {
		return {
			closeMenu: null,
			menuList: [],
		};
	},
	created() {
		this.closeMenu = this.$STORE.state.appConfig.closeMenu;
		this.getMenuList();
	},
	watch: {
		'$STORE.state.appConfig': {
			handler() {
				this.closeMenu = this.$STORE.state.appConfig.closeMenu;
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.active {
	color: #31443b;
}
.menu-item-container {
	display: flex;
	justify-content: start;
	margin-top: 70px;
}
.navigation {
	text-align: right;
	li {
		span,
		a {
			color: #ffffff;
			text-decoration: none;
			img{
				width: 24px;
			}

		}
		a {
			font-size: 24px;
		}
		span {
			font-size: 18px;
			margin-right: 10px;
		}
	}
}
.router-link-active {
	color: #2e5c67 !important;
	span,
	p {
		color: #2e5c67 !important;
	}
}
.nav-item {
	margin-bottom: 20px;
	display: block;
	width: 100%;
	.nav-link {
		background: #97cdc9;
		font-size: 16px;
		justify-content: start;
		padding: 12px 51px;

	}
}
.justify-center {
	justify-content: center;
}
.inside {
	.iconify {
		max-width: 24px;
		font-size: 24px;
	}
	.menu-title {
		color: #ffffff;
		font-size: 16px;
	}
}
.close-container{
	margin-top: 20px;
	margin-left: 20px;
	display: flex;
	justify-content: left;
	color: #ffffff;
}
</style>
